"use strict";
// Mediator class should connect every feature of Anywhere into itself
// It should handle the following deps
//
// AudioProcessor
// AudioRecordings
// StreamManager Instance
// WebRTC Manager instance
// Calibration
// Slider
// MIDI
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Imports
const ui_1 = require("../common/ui");
const ui_2 = require("./ui");
const CommandsManager_1 = __importDefault(require("../general/CommandsManager"));
const messageBroker_1 = __importDefault(require("../general/messageBroker"));
const notifications_1 = require("../utils/notifications");
const status_indicator_1 = require("../utils/status-indicator");
const audiorecordings_1 = __importDefault(require("../webaudio/audiorecordings"));
const remotePlayback_1 = require("./MIDI/remotePlayback");
const soundmeter_1 = require("../webaudio/soundmeter");
const Stream_1 = __importDefault(require("../webrtc/Stream"));
const sdputils_1 = require("../webrtc/sdputils");
const StreamManager_1 = __importDefault(require("../webrtc/StreamManager"));
const mediaDevices_1 = require("../webrtc/mediaDevices");
const common_manager_1 = require("../webrtc/common-manager");
const helpers_1 = require("../webrtc/helpers");
// on disconnect
// rtc.removePCFromPeer(peer)
// // play a nice sound
// if ($("#peerDisconnectedSound").length > 0) $("#peerDisconnectedSound")[0].play()
//
// // on reconnect
//      rtc.callPeers([peer]);
// SETUP UI LISTENERS
// $('body').on('click', '.toggleAECCommand', toggleAECCommand);
// // @Anywhere
// // @Presenter
// function toggleAECCommand() {
//   const peerId = $(this).data('id');
//   this.logger.log('id', peerId);
//   const toggleButton = $(`.toggleAECCommand[data-id='${peerId}']`);
//   const enabled = toggleButton.children('input').prop('checked');
//   toggleButton.children('input').prop('checked', !enabled);
//   const peer = getPeerConnection(peerId);
//   peer.status = 'connecting';
//   commandsManager.getCommandById('set_aec')
//     .sendTo(peerId, !enabled);
// }
// Class
class AnywhereManager extends common_manager_1.CommonManager {
    constructor(role, name, publicKey, roomKey) {
        console.time("Booting up Anywhere Manager");
        super("anywhere", role, name, publicKey, roomKey);
        this.CLOCK_DIFF = 0;
        this.recording = false;
        // for calibration
        this.knownPeerDelays = {};
        this.sessionEnded = false;
        this.initialSetup();
        console.timeEnd("Booting up Anywhere Manager");
    }
    UpdatePeer(peer) {
        common_manager_1.CommonManager.prototype.UpdatePeer.call(this, peer);
        if (peer.role !== "talent") {
            return;
        }
        if (peer.status === "connected") {
            window.setTimeout(() => {
                this.sendRoomStatus(peer.public_key);
            }, 1000);
        }
        this.UpdateTalentAudioRoutes(peer);
    }
    NewPeer(peer) {
        this.peerList.push(peer);
        // UI
        getParticipantList().addNewPeer(peer);
        let mobileDrawer = getAnywhereMobileDrawerParticipantList();
        if (mobileDrawer) {
            mobileDrawer.addNewPeer(peer);
        }
        if (this.role !== "host") {
            return;
        }
        window.setTimeout(() => {
            this.sendRoomStatus(peer.public_key);
        }, 1000);
        if (peer.role !== "talent") {
            return;
        }
        this.UpdateTalentAudioRoutes(peer);
    }
    UpdateTalentAudioRoutes(peer) {
        // check if talent 1 or 2 and set the name?
        const talent1El = document.querySelector(".audioOutput[data-id='1']");
        const talent2El = document.querySelector(".audioOutput[data-id='2']");
        const talent1Name = talent1El === null || talent1El === void 0 ? void 0 : talent1El.dataset.name;
        const talent1Id = talent1El === null || talent1El === void 0 ? void 0 : talent1El.dataset["peer-PublicKey"];
        // its talent 1
        if (talent1Name === "" ||
            talent1Name === undefined ||
            (talent1Name === peer.name && talent1Id === peer.public_key)) {
            this.SetTalentToInputEl(peer, talent1El, "#talent1Name");
        }
        else {
            this.SetTalentToInputEl(peer, talent2El, "#talent2Name");
        }
    }
    sendRoomStatus(publicKey) {
        //  window.activeUntil = Date.now() + 1000 * 1000 * 1000;
        const vuem = getVueInstance();
        if (vuem.$refs.orchestrator) {
            const orchestrator = vuem.$refs.orchestrator;
            if (orchestrator.$refs.midi && orchestrator.$refs.midi.sharedVideoMTC) {
                // send preshared video
                messageBroker_1.default.sendCommand("loadSharedVideo", publicKey, {
                    mtc: orchestrator.$refs.midi.sharedVideoMTC,
                    url: orchestrator.$refs.midi.sharedVideoURL,
                });
            }
        }
    }
    SetTalentToInputEl(peer, talentSelectEl, talentNameId) {
        let talentEl = document.querySelector(talentNameId);
        if (talentEl)
            talentEl.innerHTML = peer.name;
        if (talentSelectEl) {
            talentSelectEl.dataset.name = peer.name;
            talentSelectEl.dataset["peer-PublicKey"] = peer.public_key;
        }
    }
    handlePeerDisconnected(data) {
        this.logger.log("Peer disconnected, remove the PC", data);
        this.rtc.Close(data.public_key);
        common_manager_1.CommonManager.prototype.handlePeerDisconnected.call(this, data);
        const pk = data.public_key;
        if (this.role != "host") {
            return;
        }
        const t1El = document.querySelector(".audioOutput[data-id='1']");
        const t2El = document.querySelector(".audioOutput[data-id='2']");
        if (t1El.dataset["peer-PublicKey"] == pk) {
            // remove t1
            const talent1Name = document.querySelector("#talent1Name");
            talent1Name.innerHTML = "";
            t1El.dataset.name = "";
            t1El.dataset["peer-PublicKey"] = "";
        }
        if (t2El.dataset["peer-PublicKey"] == pk) {
            // remove t2
            const talent2Name = document.querySelector("#talent2Name");
            talent2Name.innerHTML = "";
            t2El.dataset.name = "";
            t2El.dataset["peer-PublicKey"] = "";
        }
    }
    // initializes components and establishes a comunication path between them
    initialSetup() {
        var _a;
        // This is needed for:
        // - to check whether to listen to input changes or not in media devices
        // - It may be used for something else
        this.useSFU = false;
        common_manager_1.CommonManager.prototype.initialSetup.call(this);
        // TODO: I think talent doesnt need this actully
        if (this.role == "talent" || this.role == "host") {
            this.setupAudioRecordings();
        }
        if (this.role == "guest") {
            CommandsManager_1.default
                .registerNewCommand("anywhere--start_recording", () => {
                var _a;
                (_a = document.querySelector('#recordingOn')) === null || _a === void 0 ? void 0 : _a.classList.toggle('hidden', false);
            })
                .registerNewCommand("anywhere--stop_recording", () => {
                var _a;
                (_a = document.querySelector('#recordingOn')) === null || _a === void 0 ? void 0 : _a.classList.toggle('hidden', true);
            });
        }
        // MIDI
        // TODO: handle commands from RemotePlayback
        if (this.role != "host") {
            const videoElem = document.querySelector("#remoteVideo");
            if (videoElem == null) {
                return;
            }
            this.playbackManager = new remotePlayback_1.SlavePlayback(this.role, CommandsManager_1.default, videoElem, this.publicKey);
            CommandsManager_1.default.registerNewCommand("anywhere--set-audio-bitrate", (data) => {
                if (this.rtc) {
                    this.rtc.SetBitrateForAudio(Math.max(parseInt(data.args), 6000)); // minimum bitrate is 6000
                }
            });
        }
        if (this.role == "host") {
            CommandsManager_1.default.registerNewCommand("anywhere--start_recording", (data) => { })
                .registerNewCommand("anywhere--stop_recording", (data) => { })
                .registerNewCommand("anywhere--start_upload", (data) => { })
                .registerNewCommand("anywhere--set_recording_name", (data) => { });
        }
        (_a = document.querySelector("#main")) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
        if (this.role === "host") {
            this.playbackManager = remotePlayback_1.MasterPlayback.getInstance(CommandsManager_1.default);
        }
        this.setupCalibration();
        // window.setInterval(() => {
        //   pc.sendMessageDataChannel({ type: 'latency',
        //                               time: Date.now() + this.CLOCK_DIFF,
        //                               mesage: 'This message was sent to get the latency' });
        // }, 5000);
        this.getClockDrift();
        // setup clock drift checker
        window.setInterval(() => {
            this.getClockDrift();
        }, 30000); // every 30 seconds
        // update stats for each talent every second
        window.setInterval(() => {
            const talentsConnected = this.peerList.filter((peer) => peer.role == "talent" && peer.status == "connected");
            talentsConnected.forEach((peer) => {
                var _a, _b;
                const stats = (_b = (_a = this.rtc) === null || _a === void 0 ? void 0 : _a.getPC(peer.public_key)) === null || _b === void 0 ? void 0 : _b.getStats();
                const peerC = getPeerConnection(peer.public_key);
                if (peerC && stats && peer.component) {
                    peer.component.updateStats(stats);
                }
            });
        }, 1000);
    }
    // ==================
    // CALIBRATIONS
    // ===============
    setupCalibration() {
        // Create an AudioContext.
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        this.calibrationSound = new Audio("/audio/calibration-audio.mp3");
        // When the audio data is loaded, start the audio manipulation.
        this.calibrationSound.addEventListener("loadeddata", function () {
            // Create a media element source.
            const source = audioContext.createMediaElementSource(this);
            // Create a StereoPannerNode.
            const panner = audioContext.createStereoPanner();
            // Set the pan to the far right.
            panner.pan.value = -1;
            // Connect the source to the panner, and the panner to the destination.
            source.connect(panner);
            panner.connect(audioContext.destination);
        });
        let calibratePeersButton = document.querySelector("#calibratePeers");
        if (calibratePeersButton) {
            calibratePeersButton.classList.remove("hidden");
            calibratePeersButton.addEventListener("click", () => {
                this.calibrate(calibratePeersButton);
            });
        }
    }
    calibrate(calibrateEl) {
        calibrateEl.setAttribute("disabled", "disabled");
        calibrateEl.classList.remove("btn-primary");
        calibrateEl.classList.add(...["btn-secondary", "disabled", "btn-loading"]);
        let calibrateElSpan = calibrateEl.querySelector("span");
        if (calibrateElSpan == null) {
            return;
        }
        calibrateElSpan.innerHTML = "Calibrating...";
        // add a bit of a delay otherwise the animation doesn't show
        window.setTimeout(() => { calibrateEl.classList.add("loading"); }, 10);
        if (this.calibrationSound == null) {
            this.logger.error("Calibration sound is null");
            return;
        }
        // Play twice the calibration sound, 2 seconds after it is done
        // first calibration
        this.calibrateTalent();
        window.setTimeout(() => { this.calibrationSound.play(); }, 2000);
        // second calibration
        window.setTimeout(() => { this.calibrateTalent(); }, 4000);
        window.setTimeout(() => {
            this.calibrationSound.play();
            this.peerList
                .filter((peer) => peer.role == "talent" && peer.status == "connected")
                .forEach((peer) => { peer.streamChain[1].pan.value = 0; });
        }, 6000);
        // set back everything to normal after second calibration is done
        window.setTimeout(() => {
            calibrateEl.classList.remove(...["btn-secondary", "disabled", "btn-loading", "loading"]);
            calibrateEl.classList.add("btn-primary");
            calibrateEl.removeAttribute("disabled");
            calibrateElSpan.innerHTML = "Calibrate talent";
        }, 9000);
    }
    endSession(reason) {
        common_manager_1.CommonManager.prototype.endSession.call(this);
        // remove my stream and shut off socket
        if (this.sock)
            this.sock.stop();
        StreamManager_1.default.removeAllStreams();
        if (this.rtc && this.rtc.pcs) {
            for (const [key, value] of Object.entries(this.rtc.pcs)) {
                value === null || value === void 0 ? void 0 : value.Close();
                this.rtc.pcs[key] = null;
            }
        }
        if (reason == "USER") {
            let hangupButtonEl = document.querySelector("#hangup-button");
            if (hangupButtonEl) {
                hangupButtonEl.classList.add("hidden");
            }
            let disconnectMessage = document.querySelector("#endOfSession .host-disconnect-message");
            if (disconnectMessage) {
                disconnectMessage.classList.add("hidden");
            }
            let userDisconnectMessage = document.querySelector("#endOfSession .user-disconnect-message");
            if (userDisconnectMessage)
                userDisconnectMessage.classList.remove("hidden");
        }
    }
    getClockDrift() {
        fetch(`${this.uri}/get-clock-drift`, {
            body: `timestamp=${Date.now()}`,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            method: "POST",
        })
            .then((res) => res.json())
            .then((data) => {
            const CLOCK_DIFF = (0, remotePlayback_1.setClockDrift)(data.message, data.sent_at);
            this.CLOCK_DIFF = CLOCK_DIFF;
            // this.logger.log("Clock drift is", data.message, data.sent_at, " Drift is", CLOCK_DIFF);
            this.playbackManager.setClockDiff(CLOCK_DIFF);
        });
    }
    setupUI() {
        (0, ui_1.setupUI)(this, this.role == "guest");
        (0, ui_2.setupUI)(this);
    }
    // @Anywhere
    toggleRecording() {
        var _a, _b, _c, _d, _e;
        let recordAllBtn = document.querySelector("#recordAll");
        if (!this.recording) {
            // start recording
            let startRecording = CommandsManager_1.default.getCommandById("anywhere--start_recording");
            startRecording === null || startRecording === void 0 ? void 0 : startRecording.sendAll({});
            this.recording = true;
            (_a = recordAllBtn === null || recordAllBtn === void 0 ? void 0 : recordAllBtn.querySelector(".recording")) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
            (_b = recordAllBtn === null || recordAllBtn === void 0 ? void 0 : recordAllBtn.querySelector(".not-recording")) === null || _b === void 0 ? void 0 : _b.classList.add("hidden");
        }
        else {
            // stop recording
            (_c = CommandsManager_1.default.getCommandById("anywhere--stop_recording")) === null || _c === void 0 ? void 0 : _c.sendAll({});
            this.recording = false;
            (_d = recordAllBtn === null || recordAllBtn === void 0 ? void 0 : recordAllBtn.querySelector(".recording")) === null || _d === void 0 ? void 0 : _d.classList.add("hidden");
            (_e = recordAllBtn === null || recordAllBtn === void 0 ? void 0 : recordAllBtn.querySelector(".not-recording")) === null || _e === void 0 ? void 0 : _e.classList.remove("hidden");
        }
    }
    setupAudioRecordings() {
        let recordAllBtn = document.querySelector("#recordAll");
        if (recordAllBtn) {
            recordAllBtn.addEventListener("click", () => {
                this.toggleRecording();
            });
        }
        messageBroker_1.default.registerNewMessageType("finish_upload", (data) => {
            const peer = getPeerConnection(data.message.sender);
            if (peer)
                peer.component.handleFinishUpload();
        });
        messageBroker_1.default.registerNewMessageType("stopped_recording", (data) => {
            const peer = getPeerConnection(data.message.sender);
            if (peer)
                peer.component.setUploadAvailable();
        });
        if (this.role == "talent") {
            let uploadTask;
            this.audioRecorder = new audiorecordings_1.default((event, data) => {
                switch (event) {
                    case "updateSessionInfo":
                        common_manager_1.CommonManager.prototype.sendSessionInfo.call(this, { isRecording: data.isRecording });
                        break;
                    case "stopped_recording":
                        messageBroker_1.default.sendMessage({ sender: this.publicKey }, "stopped_recording");
                        break;
                    case "finish_upload":
                        messageBroker_1.default.sendMessage({ sender: this.publicKey }, "finish_upload");
                        uploadTask.done();
                        break;
                    case "uploadingRecording":
                        uploadTask = (0, status_indicator_1.addTask)({
                            id: "UPLOAD_AUDIO",
                            determinate: true,
                            message: "Uploading recordings...",
                        });
                        break;
                    case "errorUploading":
                        uploadTask.error();
                        break;
                }
            });
        }
    }
    // TODO: Move to MIDI maybe?
    // Sends a "calibration" command for all talents
    calibrateTalent() {
        const talentsConnected = this.peerList.filter((peer) => peer.role == "talent" && peer.status == "connected");
        for (let i = 0; i < talentsConnected.length; i += 1) {
            const peer = talentsConnected[i];
            const playAt = Date.now() + this.CLOCK_DIFF + 2000; // play 2 seconds from now
            peer.playAt = playAt;
            peer.streamChain[1].pan.value = 1;
            let startCalibrationCommand = CommandsManager_1.default.getCommandById("start_calibration");
            startCalibrationCommand === null || startCalibrationCommand === void 0 ? void 0 : startCalibrationCommand.sendTo(peer.public_key, playAt);
        }
    }
    addTalentAudio(streamManager) {
        // audio should not be default but the one the talent chose on the steps
        const talentSource = document.querySelector(".audioSource[data-id='2']");
        // get the selected not the default
        const audioConstraints = (0, mediaDevices_1.getAudioConstraints)(talentSource.value, false);
        const talentAudioStream = new Stream_1.default({
            label: "TALENT_AUDIO",
            kind: "AUDIO",
            constraints: { audio: audioConstraints, video: false },
            enabled: true,
        });
        talentAudioStream.on("update[enabled]", ui_2.updateTalentAudioUI);
        talentAudioStream.on("GOT_STREAM", (label, stream) => {
            (0, soundmeter_1.setupSoundMeter)("#soundMeterTalent", stream, "bar");
            let localAudio = document.querySelector("#localAudio3");
            if (localAudio)
                localAudio.srcObject = stream;
        });
        this.talentAudio = talentAudioStream;
        streamManager.addStream(talentAudioStream);
        return streamManager;
    }
    addLocalAudio(streamManager) {
        const trackEnabled = this.role === "talent" || this.role === "host";
        let audioConstraints = (0, mediaDevices_1.getAudioConstraints)("default", this.hasEchoCancellation);
        if (this.role === "talent") {
            // audio should not be default but the one the talent chose on the steps
            const localSource = document.querySelector(".audioSource[data-id='0']");
            const hasEchoCancellation = false; // talent never has audioConstraints...
            audioConstraints = (0, mediaDevices_1.getAudioConstraints)(localSource.value, hasEchoCancellation);
        }
        if (this.role === "host") {
            // audio should not be default but the one the talent chose on the steps
            const guestSource = document.querySelector(".audioSource[data-id='0']");
            // get the selected not the default
            audioConstraints = (0, mediaDevices_1.getAudioConstraints)(guestSource.value, false);
        }
        const localAudioStream = new Stream_1.default({
            label: "LOCAL_AUDIO",
            kind: "AUDIO",
            constraints: { audio: audioConstraints, video: false },
            enabled: trackEnabled,
        });
        //  @UI
        (0, ui_2.updateLocalAudioUI)(trackEnabled);
        localAudioStream.on("update[enabled]", ui_2.updateLocalAudioUI);
        localAudioStream.on("GOT_STREAM", (label, stream) => {
            var _a, _b;
            const webAudio = window.webAudio;
            if (webAudio && this.role != "guest") {
                stream = webAudio.applyFilter(stream);
            }
            // reset Soundmeters
            (0, soundmeter_1.setupSoundMeter)(".soundMeterMain", stream);
            const localAudio = document.querySelector("#localAudio");
            if (localAudio)
                localAudio.srcObject = stream;
            // @Anywhere
            (_a = this.audioRecorder) === null || _a === void 0 ? void 0 : _a.setRecordingStream(stream);
            (_b = this.localAudio) === null || _b === void 0 ? void 0 : _b.setMediaStream(stream);
        }); // end of got stream event;
        this.localAudio = localAudioStream;
        streamManager.addStream(localAudioStream);
        return streamManager;
    }
    toggleLocalAudio(enabled) {
        var _a;
        (_a = this.localAudio) === null || _a === void 0 ? void 0 : _a.update({ enabled });
    }
    toggleTalentAudio(enabled) {
        var _a;
        (_a = this.talentAudio) === null || _a === void 0 ? void 0 : _a.update({ enabled });
    }
    setupStreams() {
        // Local audio
        this.addLocalAudio(StreamManager_1.default);
        // This is the stream labeled "TO TALENT"
        if (this.role === "host") {
            this.addTalentAudio(StreamManager_1.default);
        }
    }
    handleAudioStream(stream, peerRole, id, label) {
        var _a, _b;
        if (this.reconnectionTask && this.reconnectionTask.valid()) {
            this.reconnectionTask.done();
        }
        const peer = getPeerConnection(id);
        if (this.role !== "host" && peerRole === "host") {
            this.handleAudioFromHost(stream, id);
        }
        else {
            this.handleAudioFromPeer(stream, peerRole, id, peer);
        }
        // setup sound-meter
        peer.status = "connected";
        (_a = peer.component) === null || _a === void 0 ? void 0 : _a.addStream(stream);
        if (this.knownPeerDelays[id] != null) {
            const delay = this.knownPeerDelays[id][this.knownPeerDelays[id].length - 1];
            this.adjustPeerLatency(peer.name, peer.public_key, id, delay);
        }
        (_b = peer.component) === null || _b === void 0 ? void 0 : _b.$on("speaking", () => {
            if (peer && peer.playAt) {
                // set the delay properly
                let delay = Date.now() + this.CLOCK_DIFF - peer.playAt;
                if (delay > 2000) {
                    // if theres an error getting the latency don't set it higher than 2s
                    delay = 2000;
                }
                if (delay < -1000) {
                    // this is impossible set the delay to 2000
                    delay = 0;
                    this.logger.warn("Ignoring delay cuz its negative");
                }
                else {
                    if (this.knownPeerDelays[id] == null) {
                        this.knownPeerDelays[id] = [];
                    }
                    this.knownPeerDelays[id] = [...this.knownPeerDelays[id], delay];
                    this.adjustPeerLatency(peer.name, peer.public_key, id, delay);
                    peer.playAt = null;
                }
            }
            this.showTalentSpeaking(id);
        });
    }
    showTalentSpeaking(id) {
        // update UI to show that talent is speaking
        if (this.role != "host") {
            return;
        }
        const t1 = document.querySelector(".audioOutput[data-id='1']").dataset["peer-PublicKey"];
        const t2 = document.querySelector(".audioOutput[data-id='2']").dataset["peer-PublicKey"];
        let onSpeakingStyle = "text-blue-600";
        if (t1 == id) {
            const talent1Name = document.querySelector("#talent1Name");
            if (talent1Name != null) {
                talent1Name.classList.add(onSpeakingStyle);
                talent1Name.classList.remove("text-gray-500");
                talent1Name.style.textShadow = "0 0 14px #00F";
                window.setTimeout(() => {
                    talent1Name.classList.add("text-gray-500");
                    talent1Name.classList.remove(onSpeakingStyle);
                    talent1Name.style.textShadow = "none";
                }, 1000);
            }
        }
        if (t2 == id) {
            const talent2Name = document.querySelector("#talent2Name");
            if (talent2Name != null) {
                talent2Name.classList.add(onSpeakingStyle);
                talent2Name.classList.remove("text-gray-500");
                talent2Name.style.textShadow = "0 0 14px #00F";
                window.setTimeout(() => {
                    talent2Name.classList.remove(onSpeakingStyle);
                    talent2Name.classList.add("text-gray-500");
                    talent2Name.style.textShadow = "none";
                }, 1000);
            }
        }
    }
    adjustPeerLatency(peerName, peerPublicKey, id, delayInMs) {
        // get the variance between the max delay and the min delay
        const maxDelay = Math.max(...this.knownPeerDelays[id]);
        const minDelay = Math.min(...this.knownPeerDelays[id]);
        const variance = maxDelay - minDelay;
        (0, notifications_1.localNotify)(`Adjusting peer ${peerName} - ${delayInMs}ms - Δ${variance}ms`, "success");
        // data-peer--public-key
        const t1 = document.querySelector(".audioOutput[data-id='1']").dataset["peer-PublicKey"];
        const t2 = document.querySelector(".audioOutput[data-id='2']").dataset["peer-PublicKey"];
        if (t1 == id) {
            let talent1Latency = document.querySelector("#talent1Latency");
            if (talent1Latency != null) {
                talent1Latency.innerHTML = `${delayInMs}ms - Δ${variance}ms`;
            }
        }
        if (t2 == id) {
            let talent2Latency = document.querySelector("#talent2Latency");
            if (talent2Latency != null) {
                talent2Latency.innerHTML = `${delayInMs}ms - Δ${variance}ms`;
            }
        }
        let setDelayCommand = CommandsManager_1.default.getCommandById("anywhere--set_delay");
        if (setDelayCommand != null) {
            setDelayCommand.sendTo(peerPublicKey, delayInMs);
        }
    }
    handleAudioFromHost(stream, target) {
        this.logger.log("Handle audio from host", stream, target);
        // TODO: Remove this true
        if (this.hostAudioStream == null || this.hostAudioStream.id === stream.id) {
            this.hostAudioStream = stream;
            const audio = document.querySelector(`#audio_${target}`);
            if (audio) {
                audio.srcObject = this.hostAudioStream;
            }
            else {
                this.logger.error("Unable to add audio src object");
            }
            (0, soundmeter_1.setupSoundMeter)("#soundMeterMaster", this.hostAudioStream, target, "bar");
        }
        else {
            this.logger.log("UNKNOWN TRACK, adding to DOM anyways");
            common_manager_1.CommonManager.prototype.handleAudioStream.call(this, stream, "host", target, "unknown");
        }
    }
    handleAudioFromPeer(stream, peerRole, target, peer) {
        this.logger.log("Handle audio from peer", stream, peerRole, target);
        if (stream == null) {
            this.logger.error("ANYWHERE: Stream is null");
            return;
        }
        // HACK to make audio work to  "split" diferent sources https://bugs.chromium.org/p/webrtc/issues/detail?id=5525
        // if this tag is not set to a dummy thing the createMediaStreamSource wont work
        const auxAudio = document.querySelector(`#aux_audio_${target}`);
        if (auxAudio) {
            auxAudio.srcObject = stream;
            auxAudio.muted = true; // aux audio is always muted
        }
        else {
            this.logger.error("Unable to set aux audio, target not found");
        }
        // # END OF HACK
        const audio = document.querySelector(`#audio_${target}`);
        if (audio == null) {
            // create an audio element
            const audioEl = document.createElement("audio");
            audioEl.id = `audio_${target}`;
            audioEl.autoplay = true;
            audioEl.muted = true;
            audioEl.controls = true;
            audioEl.style.display = "none";
            audioEl.play();
            document.body.appendChild(audioEl);
        }
        // Always unmute audio as we want to always hear it
        audio.muted = false;
        if (this.role === "host") {
            const ctx = new AudioContext();
            const srcNode = ctx.createMediaStreamSource(stream);
            const destNode = ctx.createMediaStreamDestination();
            // we can add here a panner for stereo
            let panner = ctx.createStereoPanner();
            panner.pan.value = 0;
            srcNode.connect(panner);
            panner.connect(destNode);
            peer.streamChain = [srcNode, panner, destNode];
            if (peerRole === "guest") {
                audio.srcObject = stream;
            }
            else if (peerRole === "talent") {
                audio.srcObject = destNode.stream;
                // # END OF HACK
            }
            else {
                audio.srcObject = stream;
            }
        }
        else {
            audio.srcObject = stream;
        }
    }
    sdpTransformer(sdp, type, participantKey) {
        let peerRole = "";
        this.peerList.forEach((p) => {
            if (p.public_key == participantKey) {
                peerRole = p.role;
            }
        });
        if (peerRole == "") {
            this.logger.error("Couldn't find role for peer");
        }
        let transformedSDP = sdp;
        let audioSettings = {
            bitrate: 640,
            hasDTX: false,
            hasStereo: true,
        };
        switch (this.role) {
            case "host":
                audioSettings.bitrate = 640;
                audioSettings.hasStereo = peerRole === "talent" ? false : true;
                break;
            case "talent":
                audioSettings.bitrate = 640;
                audioSettings.hasStereo = false;
                break;
            case "director":
            case "guest":
                audioSettings.bitrate = 320;
                audioSettings.hasStereo = true;
                break;
        }
        const qualitySettings = {
            audio: audioSettings,
        };
        transformedSDP = (0, sdputils_1.defaultBandwithOptions)(transformedSDP, null, // video quality, "4K"
        qualitySettings.audio.bitrate, qualitySettings.audio.hasDTX, qualitySettings.audio.hasStereo);
        return transformedSDP;
    }
    sendSessionInfo(params) {
        let isRecording = false;
        if (params) {
            isRecording = params.isRecording;
        }
        const audioInputSelected = localStorage.getItem("preferredAudioInput0");
        // @ts-ignore: window
        const { uploadSpeed, downloadSpeed } = window;
        const data = {
            sender: this.publicKey,
            uploadSpeed,
            downloadSpeed,
            selectedInput: "",
            isRecording,
        };
        if (this.localAudio && this.localAudio.mediaStream) {
            const stats = (0, helpers_1.getTrackStats)(this.localAudio.mediaStream);
            data.selectedInput = `${audioInputSelected} - ${stats}`;
        }
        messageBroker_1.default.sendMessage(data, "session_info");
    }
    async onDisconnected(state) {
        // add
        if (this.sessionEnded || this.serverDisconnected)
            return;
        if (this.reconnectionTask == null || this.reconnectionTask.valid() == false) {
            let wasOnline = await isOnline();
            if (wasOnline == false) {
                this.reconnectionTask = (0, status_indicator_1.addTask)({
                    id: "ws_connection",
                    determinate: false,
                    message: "Reestablishing connection",
                });
                let interval = window.setInterval(async () => {
                    let online = await isOnline();
                    // this.rtc.canCallPeers = online;
                    if (online) {
                        this.sock.stop();
                        this.reconnectionTask.done();
                        this.setupWebSocketConnection(this.wsuri, () => {
                            // on Connected
                            window.setTimeout(() => {
                                // Lets log in when setup is done
                                this.Login();
                            }, 1000);
                        });
                        window.clearInterval(interval);
                    }
                }, 2000);
            }
        }
    }
}
// https://dev.to/maxmonteil/is-your-app-online-here-s-how-to-reliably-know-in-just-10-lines-of-js-guide-3in7
function getRandomString() {
    return Math.random().toString(36).substring(2, 15);
}
async function isOnline() {
    if (!window.navigator.onLine)
        return false;
    // avoid CORS errors with a request to your own origin
    const url = new URL(window.location.origin);
    // random value to prevent cached responses
    url.searchParams.set('rand', getRandomString());
    try {
        const response = await fetch(url.toString(), { method: 'HEAD' });
        return response.ok;
    }
    catch (_a) {
        return false;
    }
}
function getVueInstance() {
    return vm;
}
function getParticipantListComponent() {
    const vuem = getVueInstance();
    if (vuem.$refs.orchestrator)
        return vuem.$refs.orchestrator.$refs.participantList;
    if (vuem.$refs.participantList)
        return vuem.$refs.participantList;
    return {};
}
function getPeerConnection(id) {
    const participantList = getParticipantListComponent();
    if (!participantList)
        return null;
    return participantList.getPeerConnection(id);
}
function getParticipantList() {
    const vuem = getVueInstance();
    if (vuem.$refs.orchestrator)
        return vuem.$refs.orchestrator.$refs.participantList;
    if (vuem.$refs.participantList)
        return vuem.$refs.participantList;
    return {};
}
function getAnywhereMobileDrawerParticipantList() {
    const vuem = getVueInstance();
    if (vuem.$refs.mirrorMobileDrawer) {
        if (vuem.$refs.mirrorMobileDrawer.$refs.participantList) {
            return vuem.$refs.mirrorMobileDrawer.$refs.participantList;
        }
    }
    return null;
}
exports.default = AnywhereManager;
